import { render } from "./ReleaseStatusTable.vue?vue&type=template&id=1f34eb3c&scoped=true&ts=true"
import script from "./ReleaseStatusTable.vue?vue&type=script&lang=ts"
export * from "./ReleaseStatusTable.vue?vue&type=script&lang=ts"

import "./ReleaseStatusTable.vue?vue&type=style&index=0&id=1f34eb3c&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f34eb3c"]])

export default __exports__